(() => {
  const drawer = document.getElementById('BidFilterDrawer');
  if (!drawer) return;

  const openButtons = document.querySelectorAll('[data-bid-filter-open]');
  const closeButtons = drawer.querySelectorAll('[data-bid-filter-close]');
  const panel = drawer.querySelector('.bid-filter-drawer__panel');

  const setExpanded = (isOpen) => {
    openButtons.forEach((btn) => btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false'));
  };

  const open = () => {
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    document.documentElement.classList.add('bid-filter-open');
    setExpanded(true);
    const closeBtn = drawer.querySelector('.bid-filter-drawer__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  };

  const close = () => {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('bid-filter-open');
    setExpanded(false);
    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 280);
  };

  openButtons.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      open();
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      close();
    });
  });

  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  if (panel) {
    panel.addEventListener('click', (event) => event.stopPropagation());
  }
})();
